export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/jsonata.worker.429957a47771ac4f999d.worker.js");
}
